/** Rail icon for sticker trades: two stickers with swap arrows (toon style, 3px #5a2e1f outline). */
import type { JSX } from 'preact';

const OUT = '#5a2e1f';

export function TradeIcon({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect x="2.5" y="3.5" width="13" height="13" rx="3" fill="#ffc845" stroke={OUT} stroke-width="2.4" transform="rotate(-8 9 10)" />
      <rect x="16.5" y="15.5" width="13" height="13" rx="3" fill="#8e6cef" stroke={OUT} stroke-width="2.4" transform="rotate(8 23 22)" />
      <path d="M19 6h6.5v5" fill="none" stroke={OUT} stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M23 9l2.5 2.5L28 9" fill="none" stroke={OUT} stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13 26H6.5v-5" fill="none" stroke={OUT} stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 23l-2.5-2.5L4 23" fill="none" stroke={OUT} stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
